import React from 'react';

/**
 * Individual sensor configuration card component
 */
export const SensorConfigCard = ({ title, icon, config, onChange, error }) => {
  const total = config.max - config.min;
  const yellowWidth = total > 0 ? ((config.idealMin - config.min) / total) * 100 : 0;
  const greenWidth = total > 0 ? ((config.idealMax - config.idealMin) / total) * 100 : 0;
  const redWidth = total > 0 ? ((config.max - config.idealMax) / total) * 100 : 0;

  return (
    <div className="config-card">
      <div className="config-card-header">
        <span className="config-card-icon">{icon}</span>
        <span className="config-card-title">{title}</span>
      </div>

      {/* RANGO PERMITIDO */}
      <div className="config-group">
        <div className="config-group-title">Rango permitido</div>
        <div className="config-row config-row-large">
          <div className="config-field">
            <label className="config-label">Min</label>
            <input
              type="number"
              className={`config-input ${error ? 'error' : ''}`}
              value={config.min}
              onChange={(e) => onChange('min', e.target.value === '' ? '' : parseFloat(e.target.value))}
            />
          </div>
          <div className="config-field">
            <label className="config-label">Max</label>
            <input
              type="number"
              className={`config-input ${error ? 'error' : ''}`}
              value={config.max}
              onChange={(e) => onChange('max', e.target.value === '' ? '' : parseFloat(e.target.value))}
            />
          </div>
        </div>
      </div>

      {/* RANGO IDEAL */}
      <div className="config-group">
        <div className="config-group-title">Rango ideal</div>
        <div className="config-row config-row-large">
          <div className="config-field">
            <label className="config-label">Min ideal</label>
            <input
              type="number"
              className={`config-input ${error ? 'error' : ''}`}
              value={config.idealMin}
              onChange={(e) => onChange('idealMin', e.target.value === '' ? '' : parseFloat(e.target.value))}
            />
          </div>
          <div className="config-field">
            <label className="config-label">Max ideal</label>
            <input
              type="number"
              className={`config-input ${error ? 'error' : ''}`}
              value={config.idealMax}
              onChange={(e) => onChange('idealMax', e.target.value === '' ? '' : parseFloat(e.target.value))}
            />
          </div>
        </div>
      </div>

      {error && <div className="config-error">{error}</div>}

      {/* Color Preview Bar */}
      <div className="color-preview">
        <div className="color-preview-label">Mapa de colores</div>
        <div className="color-preview-bar">
          <div className="color-zone yellow" style={{ width: `${yellowWidth}%` }}>
            Bajo
          </div>
          <div className="color-zone green" style={{ width: `${greenWidth}%` }}>
            Ideal
          </div>
          <div className="color-zone red" style={{ width: `${redWidth}%` }}>
            Alto
          </div>
        </div>

        <div className="color-preview-labels">
          <span>{config.min}</span>
          <span>{config.idealMin}</span>
          <span>{config.idealMax}</span>
          <span>{config.max}</span>
        </div>
      </div>
    </div>
  );
};
